import { render, staticRenderFns } from "./ParkingBarriersArchive.vue?vue&type=template&id=0c31262a&scoped=true"
import script from "./ParkingBarriersArchive.vue?vue&type=script&lang=js"
export * from "./ParkingBarriersArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c31262a",
  null
  
)

export default component.exports